import './main.css';
import './animations.css';
import { bulletins } from "../../components/widgets/bulletins-section/bulletins";
import { KnowledgeBase } from "../../components/widgets/knowledge-base-section/knowledge-base";
import { presentationModal } from "../../components/widgets/presentation-modal/presentation-modal";
import { Header } from "./../../components/widgets/header/header";
import { IndexPageAnimations } from "./animations";
import { smoothScroll } from "./smooth-scroll";

export function initMainPage() {
  Header.init();
  KnowledgeBase.init();
  smoothScroll.init();
  IndexPageAnimations.init();
  bulletins.init();
}